export default __webpack_public_path__ + "static/media/upload-dragndrop.7900329f.gif";